/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeConteneurMobileDto } from '../models/type-conteneur-mobile-dto';


/**
 * Fonctions de gestion des types de conteneurs mobiles
 */
@Injectable({
  providedIn: 'root',
})
export class TypesConteneursMobilesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeConteneurMobileGetList
   */
  static readonly TypeConteneurMobileGetListPath = '/api/types-conteneurs-mobiles/list';

  /**
   * Renvoie la liste des types de conteneurs mobiles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeConteneurMobileGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeConteneurMobileGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeConteneurMobileDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesConteneursMobilesService.TypeConteneurMobileGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeConteneurMobileDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types de conteneurs mobiles.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeConteneurMobileGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeConteneurMobileGetList(params?: {
  }): Observable<Array<TypeConteneurMobileDto>> {

    return this.typeConteneurMobileGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeConteneurMobileDto>>) => r.body as Array<TypeConteneurMobileDto>)
    );
  }

  /**
   * Path part for operation typeConteneurMobileLoadList
   */
  static readonly TypeConteneurMobileLoadListPath = '/api/types-conteneurs-mobiles/load-list';

  /**
   * Renvoie la liste des types de conteneurs mobiles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeConteneurMobileLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeConteneurMobileLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesConteneursMobilesService.TypeConteneurMobileLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types de conteneurs mobiles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeConteneurMobileLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeConteneurMobileLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeConteneurMobileLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeConteneurMobileGet
   */
  static readonly TypeConteneurMobileGetPath = '/api/types-conteneurs-mobiles/{id}';

  /**
   * Renvoie le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeConteneurMobileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeConteneurMobileGet$Response(params: {

    /**
     * Identifiant du type de conteneurs mobiles
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeConteneurMobileDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesConteneursMobilesService.TypeConteneurMobileGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeConteneurMobileDto>;
      })
    );
  }

  /**
   * Renvoie le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeConteneurMobileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeConteneurMobileGet(params: {

    /**
     * Identifiant du type de conteneurs mobiles
     */
    id: number;
  }): Observable<TypeConteneurMobileDto> {

    return this.typeConteneurMobileGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeConteneurMobileDto>) => r.body as TypeConteneurMobileDto)
    );
  }

  /**
   * Path part for operation typeConteneurMobilePut
   */
  static readonly TypeConteneurMobilePutPath = '/api/types-conteneurs-mobiles/{id}';

  /**
   * Met à jour le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeConteneurMobilePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeConteneurMobilePut$Response(params: {

    /**
     * Identifiant du type de conteneurs mobiles à mettre à jour
     */
    id: number;

    /**
     * Type de conteneurs mobiles
     */
    body: TypeConteneurMobileDto
  }): Observable<StrictHttpResponse<TypeConteneurMobileDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesConteneursMobilesService.TypeConteneurMobilePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeConteneurMobileDto>;
      })
    );
  }

  /**
   * Met à jour le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeConteneurMobilePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeConteneurMobilePut(params: {

    /**
     * Identifiant du type de conteneurs mobiles à mettre à jour
     */
    id: number;

    /**
     * Type de conteneurs mobiles
     */
    body: TypeConteneurMobileDto
  }): Observable<TypeConteneurMobileDto> {

    return this.typeConteneurMobilePut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeConteneurMobileDto>) => r.body as TypeConteneurMobileDto)
    );
  }

  /**
   * Path part for operation typeConteneurMobileDelete
   */
  static readonly TypeConteneurMobileDeletePath = '/api/types-conteneurs-mobiles/{id}';

  /**
   * Supprime le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeConteneurMobileDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeConteneurMobileDelete$Response(params: {

    /**
     * Identifiant du type de conteneurs mobiles à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesConteneursMobilesService.TypeConteneurMobileDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeConteneurMobileDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeConteneurMobileDelete(params: {

    /**
     * Identifiant du type de conteneurs mobiles à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeConteneurMobileDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeConteneurMobilePost
   */
  static readonly TypeConteneurMobilePostPath = '/api/types-conteneurs-mobiles';

  /**
   * Crée le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeConteneurMobilePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeConteneurMobilePost$Response(params: {

    /**
     * Type de conteneurs mobiles
     */
    body: TypeConteneurMobileDto
  }): Observable<StrictHttpResponse<TypeConteneurMobileDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesConteneursMobilesService.TypeConteneurMobilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeConteneurMobileDto>;
      })
    );
  }

  /**
   * Crée le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeConteneurMobilePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeConteneurMobilePost(params: {

    /**
     * Type de conteneurs mobiles
     */
    body: TypeConteneurMobileDto
  }): Observable<TypeConteneurMobileDto> {

    return this.typeConteneurMobilePost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeConteneurMobileDto>) => r.body as TypeConteneurMobileDto)
    );
  }

  /**
   * Path part for operation typeConteneurMobileDesactivate
   */
  static readonly TypeConteneurMobileDesactivatePath = '/api/types-conteneurs-mobiles/{id}/desactivate';

  /**
   * Désactive le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeConteneurMobileDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeConteneurMobileDesactivate$Response(params: {

    /**
     * Identifiant du type de conteneurs mobiles à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeConteneurMobileDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesConteneursMobilesService.TypeConteneurMobileDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le type de conteneurs mobiles spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeConteneurMobileDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeConteneurMobileDesactivate(params: {

    /**
     * Identifiant du type de conteneurs mobiles à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeConteneurMobileDto
  }): Observable<number> {

    return this.typeConteneurMobileDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
